module.exports = __webpack_public_path__ + "static/media/user_management_active.8454a681.svg";